import React from "react";
import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import InputField from "components/fields/InputField";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";

import { MESSAGE_SUCCES } from "actions/types";

export function CompanyAdd({ initData, onSave, validation }) {
  const [hasBrowserLocationOn, setBrowserLocation] = useState(false);
  useEffect(() => {
    // Update the document title using the browser API    document.title = `You clicked ${count} times`;
    navigator.permissions.query({ name: "geolocation" }).then(function (event) {
      console.log(this);
      console.log(event);
      if (event && "state" in event && event.state == "granted") {
        setBrowserLocation(true);
      } else {
        navigator.geolocation.getCurrentPosition(success2, error2);
      }
    });

    if ("geolocation" in navigator && !hasBrowserLocationOn) {
      //			navigator.geolocation.getCurrentPosition(success2, error2);
    } else {
      console.log("Not Available");
    }
  });

  const [data, setData] = React.useReducer(
    (state, newState) => ({ ...state, ...newState }),
    initData
  );

  const handleOnChange = (event) => {
    const { name, value } = event.target;
    setData({ ...data, [name]: value });
    if (validation[name]) {
      validation[name] = null;
    }
  };

  const onSaveWrapped = (event) => {
    event.preventDefault();
    onSave(data);
  };

  const checkBrowserLocation = function (event) {
    navigator.geolocation.getCurrentPosition(success2, error2);
  };

  // Update the map marker
  const success2 = function (position) {
    if (position) {
      if (data.location && position.coords) {
        data.location.lat = position.coords.latitude;
        data.location.lng = position.coords.longitude;
        data.location.isDirty = true;
        setData({ ...data, location: data.location });
      }

      //setBrowserLocation(true);
    }
  };

  const error2 = function (ev) {
    console.log("Failed", ev);
  };
  let kvkMuteTxt = "";
  if (data.chamberofcommerce && data.chamberofcommerce.is_checked === false) {
    kvkMuteTxt = "";
  } else if (
    data.chamberofcommerce &&
    data.chamberofcommerce.is_checked === true
  ) {
    kvkMuteTxt =
      "Laatste check op : " +
      data.chamberofcommerce.checked_on.toLocaleString("nl-NL");
  }
  const [key, setKey] = React.useState("naw");
  return (
    <>
      <div className="pb-5 mb-12 border-b border-gray-200">
        <h2 className="font-bold text-gray-900 max-md:mb-3 text-2xl/7 sm:truncate sm:text-3xl sm:tracking-tight">
          Bedrijf toevoegen
        </h2>
        <p className="mt-2 max-w-4xl text-sm text-gray-500">
          Vul hieronder de gegevens in van je bedrijf. De verplichte velden
          worden aangegeven met een sterretje (<span className="ster">*</span>
          ). Wij voeren ten alle tijden een controle uit op je bedrijfsgegevens.
        </p>
      </div>
      <Form onSubmit={onSaveWrapped} className="company-form">
        <div className="space-y-12">
          <div className="pb-12 border-b border-gray-900/10">
            <h2 className="font-semibold text-gray-900 text-base/7">
              Bedrijfsgegevens
            </h2>
            <p className="mt-1 text-gray-600 text-sm/6">
              Deze gegevens worden gecontroleerd. Zorg er dus voor dat u alle
              gegevens correct en naar waarheid invult.
            </p>

            <div className="grid grid-cols-1 gap-x-6 gap-y-8 mt-10 sm:grid-cols-6">
              <div className="space-y-5 sm:col-span-4">
                <InputField
                  lbl="Bedrijfsnaam*"
                  name="name"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                  extraClass=""
                />
                <InputField
                  lbl="KVK-nummer"
                  name="coc"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                  muteTxt={kvkMuteTxt}
                />
                <InputField
                  lbl="BTW-nummer"
                  name="vat_no"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                />
              </div>
            </div>
          </div>

          {/* Section two */}
          <div className="pb-12 border-b border-gray-900/10">
            <h2 className="font-semibold text-gray-900 text-base/7">
              Contactgegevens
            </h2>
            <p className="mt-1 text-gray-600 text-sm/6">
              Deze gegevens worden gecontroleerd. Zorg er dus voor dat u alle
              gegevens correct en naar waarheid invult.
            </p>

            <div className="grid grid-cols-1 gap-x-6 gap-y-8 mt-10 sm:grid-cols-6">
              <div className="space-y-5 sm:col-span-4">
                <InputField
                  lbl="Telefoonnummer*"
                  name="phone1"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                  extraClass=""
                />
                <InputField
                  lbl="Extra telefoonnummer"
                  name="phone2"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                />
                <InputField
                  lbl="E-mailadres 1*"
                  name="email1"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                  extraClass="c"
                />
                <InputField
                  lbl="E-mailadres 2"
                  name="email2"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                />
              </div>
            </div>
          </div>
          {/* Section three */}
          <div className="pb-12 border-b border-gray-900/10">
            <h2 className="font-semibold text-gray-900 text-base/7">
              Adresgegevens
            </h2>
            <p className="mt-1 text-gray-600 text-sm/6">
              Deze gegevens worden gecontroleerd. Zorg er dus voor dat u alle
              gegevens correct en naar waarheid invult.
            </p>

            <div className="grid grid-cols-1 gap-x-6 gap-y-8 mt-10 sm:grid-cols-6">
              <div className="space-y-5 sm:col-span-4">
                <InputField
                  lbl="Straatnaam*"
                  name="address"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                  extraClass=""
                />
                <InputField
                  lbl="Huisnummer*"
                  type="number"
                  name="house_no"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                  extraClass=""
                />
                <InputField
                  lbl="Nummer extension"
                  name="house_no_ext"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                />
                <InputField
                  lbl="Postcode*"
                  name="zipcode"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                  extraClass=""
                />
                <InputField
                  lbl="Plaats*"
                  name="residence"
                  validation={validation}
                  value={data}
                  onChange={handleOnChange}
                  extraClass=""
                />
                {hasBrowserLocationOn && (
                  <Button
                    variant="primary"
                    className="temp-btn"
                    onClick={(event) => checkBrowserLocation(event)}
                  >
                    Check huidige browser locatie
                  </Button>
                )}
              </div>
            </div>
          </div>
        </div>
        <Button type="submit" className="save-button btn-primary">
          Wijzigingen opslaan
        </Button>
      </Form>
    </>
  );
}
